<div class="static-icon-container" [id]="id" [style.background-color]="backgroundColor">
    <vpg-icon-next class="recommendation-static" [icon]="iconName"></vpg-icon-next>
</div>
